import { render, staticRenderFns } from "./InstantUpdateBooleanIconButton.vue?vue&type=template&id=90153702"
import script from "./InstantUpdateBooleanIconButton.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateBooleanIconButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports